export const MEDIA_SCREENS_BREAKOUT = {
  MOBILE: {
    MIN: 300,
    MAX: 599,
  },
  TABLET: {
    MIN: 600,
    MAX: 1199,
  },
  DESKTOP: {
    MIN: 1200,
    MAX: 4000,
  },
};
